import React, { useEffect, useState } from "react";
import { Tooltip } from "./Tooltip";
import { Link } from "react-scroll";

const ClassicHeader = ({ handleNavClick }) => {
  const [stickyHeader, setStickyHeader] = useState(false);
  const [isNavModalClose, setIsNavModalClose] = useState(true);

  const navItems = [
    { label: "Home", target: "home" },
    { label: "About", target: "about" },
    { label: "Skills", target: "services" },
    { label: "Resume", target: "resume" },
    { label: "Portfolio", target: "portfolio" },
    { label: "Contact", target: "contact" },
  ];

  const socialLinks = [
    {
      className: "social-icons-instagram",
      href: "https://www.instagram.com/goodolcaptain_brett/",
      icon: "fab fa-instagram",
      label: "Instagram",
    },
    {
      className: "social-icons-linkedin",
      href: "https://www.linkedin.com/in/brett-seibert-24b29680/",
      icon: "fab fa-linkedin-in",
      label: "Linkedin",
    },
    {
      className: "social-icons-github",
      href: "https://github.com/MaxSyber",
      icon: "fab fa-github",
      label: "Github",
    },
  ];

  useEffect(() => {
    const checkScrollTop = () => {
      const isScrolled =
        document.body.scrollTop > 180 ||
        document.documentElement.scrollTop > 180;

      setStickyHeader(isScrolled);
    };

    window.addEventListener("scroll", checkScrollTop);
    checkScrollTop();

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, []);

  return (
    <header id="header" className="sticky-top-slide">
      <nav
        className={
          "primary-menu navbar navbar-expand-lg navbar-dark bg-transparent border-bottom-0 sticky-top " +
          (stickyHeader ? "sticky-on" : "")
        }
      >
        <div className="container-fluid position-relative g-lg-4">
          <div className="col-auto col-lg-2"></div>
          <div className="col col-lg-8 navbar-accordion">
            <button
              onClick={() => {
                setIsNavModalClose(!isNavModalClose);
              }}
              className={
                isNavModalClose
                  ? "navbar-toggler ms-auto"
                  : "navbar-toggler ms-auto show"
              }
              id="navbar-toggler"
              type="button"
            >
              <span />
              <span />
              <span />
            </button>
            <div
              id="header-nav"
              className={
                isNavModalClose
                  ? "collapse navbar-collapse justify-content-center "
                  : "show navbar-collapse justify-content-center"
              }
            >
              <ul className="navbar-nav">
                {navItems.map((item) => (
                  <li className="nav-item" key={item.target}>
                    <Link
                      smooth
                      duration={500}
                      style={{ cursor: "pointer" }}
                      spy
                      activeClass="active"
                      className="nav-link"
                      to={item.target}
                      onClick={(e) => {
                        e.preventDefault();
                        setIsNavModalClose(true);
                      }}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-auto col-lg-2 d-flex justify-content-end">
            <ul className="social-icons social-icons-light">
              {socialLinks.map((link) => (
                <li className={link.className} key={link.href}>
                  <Tooltip text={link.label} placement="top">
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={link.icon} />
                    </a>
                  </Tooltip>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default ClassicHeader;
